class AnalyticsHandler {
	/**
	 * @typedef {"view" | "click"} analyticsHandlerTriggerType
	 */

	/**
	 * @param {analyticsDataInterface[]} analyticsData
	 */
	constructor(analyticsData) {
		/** @private */
		this.analyticsData = analyticsData;

		/** @private */
		this.datasetAnalyticsId = 'data-analytics-id';

		/** @private */
		this.datasetAnalyticsProvider = 'data-analytics-provider';

		/** @private */
		this.datasetAnalyticsTrigger = 'data-analytics-trigger';

		/**
		 * @private
		 * @type {Element[]}
		 *  */
		this.analyticsElements;

		/** start */
		this.refresh();
	}

	/**
	 * @param {string} analyticsId
	 */
	searchDataLayerById(analyticsId) {
		const findedItem = this.analyticsData.find(({id}) => id == analyticsId);

		return findedItem ? findedItem.dataLayer : undefined;
	}

	/**
	 * @private
	 */
	readElements() {
		return [...document.querySelectorAll(`[${this.datasetAnalyticsId}]`)];
	}

	refresh() {
		this.analyticsElements = this.readElements();
		this.deployListeners();
	}

	/**
	 * @param {string} provider
	 * @private
	 */
	parseProviderToJson(provider) {
		const providerArray = provider.split(';').map((p) => {
			const pItem = p.trim().split('=');
			return {[pItem[0]]: pItem[1]};
		});

		let providerObj = {};

		providerArray.forEach((p) => {
			Object.keys(p).forEach((pkey) => (providerObj[pkey] = p[pkey]));
		});

		return providerObj;
	}

	/**
	 * @param {object} providerObj
	 * @param {object} dataLayer
	 * @private
	 */
	deployProviderOnDatalayer(providerObj, dataLayer) {
		let dataLayerStringify = JSON.stringify(dataLayer);

		function insertProviderOnDataLayer(
			key = '',
			content = '',
			dataLayerStringify = ''
		) {
			return dataLayerStringify.replace(new RegExp(`\\%${key}`, 'g'), content);
		}

		Object.keys(providerObj).forEach((providerKey) => {
			dataLayerStringify = insertProviderOnDataLayer(
				providerKey,
				providerObj[providerKey],
				dataLayerStringify
			);
		});

		return JSON.parse(dataLayerStringify);
	}

	/**
	 * @private
	 */
	deployListeners() {
		this.analyticsElements.forEach((element) => {
			// get analytics id
			const analyticsId = element.attributes.getNamedItem(
				this.datasetAnalyticsId
			).value;

			// get analytics provider
			const analyticsProvider =
				element.attributes.getNamedItem(this.datasetAnalyticsProvider)?.value ??
				undefined;

			// get trigger typew
			const analyticsTrigger =
				element.attributes.getNamedItem(this.datasetAnalyticsTrigger)?.value ??
				undefined;

			let dataLayer = this.searchDataLayerById(analyticsId);

			if (analyticsProvider) {
				const parsedProvider = this.parseProviderToJson(analyticsProvider);
				dataLayer = this.deployProviderOnDatalayer(parsedProvider, dataLayer);
				this.removeAnatyticsAtributteFromElement(
					this.datasetAnalyticsProvider,
					element
				);
			}

			if (analyticsTrigger) {
				this.removeAnatyticsAtributteFromElement(
					this.datasetAnalyticsTrigger,
					element
				);
			}

			this.removeAnatyticsAtributteFromElement(
				this.datasetAnalyticsId,
				element
			);

			/** @type {analyticsHandlerTriggerType} */
			const triggerType = analyticsTrigger ?? 'click';
			if (dataLayer) this.addListenerOnElement(triggerType, element, dataLayer);
		});
	}

	/**
	 * @param {Element} element
	 * @param {analyticsDataInterface} dataLayer
	 * @param {analyticsHandlerTriggerType} triggerType
	 */
	addListenerOnElement(triggerType, element, dataLayer) {
		if (triggerType == 'click') {
			element.addEventListener('click', () => {
				if (window.dataLayer) window.dataLayer.push(dataLayer);
				else console.log('dataLayer gtm não encontrado em window');
			});
		}

		if (triggerType == 'view') {
			const observer = new IntersectionObserver((cb, obs) => {
				const oberverSpec = cb[0];

				if (oberverSpec.isIntersecting) {
					if (window.dataLayer) window.dataLayer.push(dataLayer);
					else {
						console.log('dataLayer gtm não encontrado em window');
					}
				}
			});
			observer.observe(element);
		}
	}

	/**
	 * @param {Element} element
	 * @param {string} attribute
	 */
	removeAnatyticsAtributteFromElement(attribute, element) {
		element.attributes.removeNamedItem(attribute);
	}
}

const analyticsHandler = new AnalyticsHandler(analyticsData);
